import { TFunction, useTranslation } from '@mint-lib/i18n';
import { Platform, useFlags } from '@mint-lib/routing-context';

import {
  NotificationTabs,
  TabKey,
  tabs,
  TabsMap,
  TabType,
} from '../constants/Tabs.jsx';

type State = {
  tabs: TabType[];
  initialTab: TabType;
};

const defaultInitialTab: TabType = {
  id: NotificationTabs.accounts,
  label: 'Accounts',
};

const getVirtualTabs = (
  platform: Platform,
  allTabs: TabsMap,
  isSettingsV2: boolean,
): TabType[] => {
  if (platform.category === 'brand_safety') {
    return platform.platform === 'ias'
      ? allTabs.default
      : allTabs.virtualBrandSafetyTabs;
  }

  return isSettingsV2 ? allTabs.default : allTabs.virtualTabs;
};

const getIntegrationTabs = (
  platform: Platform,
  t: TFunction,
  isSettingsV2: boolean,
): TabType[] => {
  const allTabs = tabs(t);
  const platformName = platform.platform;
  const platformType = platform.type;

  if (platformName in allTabs) {
    return allTabs[platformName as TabKey];
  }

  if (platformType === 'virtual') {
    return getVirtualTabs(platform, allTabs, isSettingsV2);
  }

  if (platformType === 'one_way' || platformType === 'two_way') {
    return allTabs.oneTwoWaysTabs;
  }

  return allTabs.default;
};

const useIntegrationsTabs = (integration?: Platform | null): State => {
  const { t } = useTranslation('@myn/integrations_v2');
  const ff = useFlags('@mint/arm', ['settingsMint2']);
  const isSettingsV2 = ff?.settingsMint2?.enabled;

  let intTabs: TabType[] = [defaultInitialTab];
  let initTab: TabType = defaultInitialTab;

  if (integration) {
    intTabs = getIntegrationTabs(integration, t, isSettingsV2);
    initTab = intTabs[0];
  }

  return {
    tabs: intTabs,
    initialTab: initTab,
  };
};

export default useIntegrationsTabs;
